import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/logo.png';

const translations = {
  de: {
    title: 'Rink Hockey Scoreboard',
    manual: 'Handbuch',
    videos: 'Videoanleitungen',
    changelog: 'Changelog',
    open: 'Scoreboard starten',
    language: 'Sprache',
  },
  en: {
    title: 'Rink Hockey Scoreboard',
    manual: 'Manual',
    videos: 'Video Guides',
    changelog: 'Changelog',
    open: 'Open scoreboard',
    language: 'Language',
  }
};

export default function HeaderSection({ lang = 'de', setLang }) {
  const t = translations[lang];
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center p-4">
      <div 
        className="flex items-center gap-2 text-base text-stone-900 cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => navigate('/')}
      >
        <img
          loading="lazy"
          src={logoImage}
          alt="Rink Hockey Logo"
          className="w-8 h-8 object-contain"
        />
        <span>{t.title}</span>
      </div>
      <div className="flex items-center gap-4">
        {/* Language Switcher */}
        <label className="flex items-center gap-2 text-stone-700 font-medium">
          <span>{t.language}:</span>
          <select
            className="border border-stone-300 rounded px-2 py-1 text-stone-700 bg-white focus:outline-none focus:ring-2 focus:ring-blue-200"
            value={lang}
            onChange={e => setLang && setLang(e.target.value)}
          >
            <option value="de">Deutsch</option>
            <option value="en">English</option>
          </select>
        </label>
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/manual')}
        >
          {t.manual}
        </button>
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/videos')}
        >
          {t.videos}
        </button>
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/changelog')}
        >
          {t.changelog}
        </button>
        <button 
          className="flex items-center px-5 py-3 bg-red-500 hover:bg-red-600 transition-colors text-white rounded-lg text-sm"
          onClick={() => navigate('/control')}
        >
          {t.open}
        </button>
      </div>
    </div>
  );
}